import axios from 'axios'
import i18n from './../plugins/i18n'

export default {
  loadWidgetByPosition(position) {
    return axios.get(`${i18n.locale}/api/public/cms/widget/${position}`)
  },

  loadBlogBySlug(slug, limit = 0) {
    return axios.get(`${i18n.locale}/api/public/cms/blog/${slug}/${limit}`)
  },

  loadPageBySlug(slug) {
    return axios.get(`${i18n.locale}/api/public/cms/article/${slug}`)
  },

  loadMenuBySlug(slug) {
    return axios.get(`${i18n.locale}/api/public/cms/menu/${slug}`)
  },

  getNpaCategories(page = null) {
    return axios.get(`${i18n.locale}/api/public/cms/npa/categories?page=${page}`)
  },

  getNpaDeveloper() {
    return axios.get(`${i18n.locale}/api/public/cms/npa/developers`)
  },

  getNpaData(params = null) {
    
    const url = `${i18n.locale}/api/public/search/data`

    if (params != null) {
      return axios.post(url, {
        refKeys: params
      })
    }

    return axios.post(url)
  },

  getNpaDefaultInitiator() {
    return axios.get(`${i18n.locale}/api/public/search/data_initiator`)
  },

  getNpa(type, max) {
    return axios.get(`${i18n.locale}/api/public/cms/npas_main_tab/${type}/${max}`)
  },

  getViewedNpasByIds(data) {
    return axios.post(`${i18n.locale}/api/public/cms/viewed_npas_by_ids`, data)
  },

  getAdvertisingCarousel(type) {
    return axios.get(`${i18n.locale}/api/public/cms/advertisings/${type}`)
  }
}
